import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Routes, Route } from 'react-router-dom';

import Navbar from './components/Navbar';
import PriceFilter from './components/PriceFilter';
import GiftList from './components/GiftList';
import ProductDetail from './components/ProductDetail';
import Checkout from './components/Checkout';

function App() {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [selectedPrice, setSelectedPrice] = useState(1000);
  const [cartItems, setCartItems] = useState([]);

  useEffect(() => {
    axios.get('http://localhost:8083/api/gifts')
      .then(res => {
        setProducts(res.data);
        setFilteredProducts(res.data.filter(p => p.price <= selectedPrice));
      })
      .catch(err => console.error(err));
  }, []);

  useEffect(() => {
    setFilteredProducts(products.filter(p => p.price <= selectedPrice));
  }, [selectedPrice, products]);

  return (
    <>
      <Navbar />

      <Routes>
        <Route
          path="/"
          element={
            <div style={{ display: 'flex', marginTop: '20px' }}>
              <PriceFilter
                minPrice={0}
                maxPrice={2000}
                selectedPrice={selectedPrice}
                onPriceChange={setSelectedPrice}
              />

              <div style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                gap: "20px",
                flex: 1,
                padding: "20px"
              }}>
                <GiftList gifts={filteredProducts} />
              </div>
            </div>
          }
        />

        <Route
          path="/product/:id"
          element={
            <ProductDetail
              products={products}
              cartItems={cartItems}
              setCartItems={setCartItems}
            />
          }
        />

        <Route
          path="/checkout"
          element={<Checkout cartItems={cartItems} />}
        />
      </Routes>
    </>
  );
}

export default App;
